module.exports = __webpack_public_path__ + "fonts/SEBSansSerif-Regular.446f141e.woff2";